import { Grid, Box } from "@material-ui/core";
import { Component } from "react";
import GameItem from "./GameItem";

class GameSection extends Component {
  render() {
    return (
      <Box>       
        <Grid container spacing={2}>
          {this.props.games.map((item, index) => (
            <GameItem item={item} key={index} />
          ))}
        </Grid>
      </Box>
    );
  }
}

export default GameSection
